import {
	DeliveriesDataGridBase,
	DeliveriesDataGridBaseProps,
} from "src/components/views/erp/delivery/delivery/DeliveriesDataGridBase.tsx";
import {
	DeliveriesDataGridApi_DeliveryDto,
	DeliveriesDataGridApi_DeliveryDto_CustomerOrderDto,
} from "src/api/generated/erp/delivery/api/deliveriesDataGridApi.ts";
import i18n from "i18next";
import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";
import { AavoGridColDef } from "src/components/common/dataGrid/types.tsx";

export interface CustomerOrderDeliveriesDataGridProps {
	fetchData: DeliveriesDataGridBaseProps["fetchData"];
}

export const CustomerOrderDeliveriesDataGrid = ({ fetchData }: CustomerOrderDeliveriesDataGridProps) => {
	const { defaultSiteId } = useGlobalInitData();
	const customerOrderColumns: AavoGridColDef<DeliveriesDataGridApi_DeliveryDto>[] = [
		{
			field: "siteName",
			headerName: i18n.t("site"),
			position: 1,
		},
		{
			field: "customerOrderId",
			filterable: false,
			sortable: false,
			headerName: i18n.t("order_no"),
			width: 80,
			position: 2,
			valueGetter: (_, row) =>
				getFieldFromConnectedCustomerOrders(row, (order) => order.customerOrderId.toString()),
		},
		{
			field: "customer",
			filterable: false,
			sortable: false,
			headerName: i18n.t("customer"),
			width: 200,
			position: 3,
			valueGetter: (_, row) => getFieldFromConnectedCustomerOrders(row, (order) => order.customerName),
		},
		{
			field: "orderReference",
			filterable: false,
			sortable: false,
			headerName: i18n.t("order_reference"),
			width: 200,
			position: 4,
			valueGetter: (_, row) => getFieldFromConnectedCustomerOrders(row, (order) => order.orderReference),
		},
	];

	return (
		<DeliveriesDataGridBase
			gridId={"F87A8E4E5860D928"}
			showSearchField
			showOnlyUndeliveredByDefault
			fetchData={fetchData}
			extraColumns={customerOrderColumns}
			// Add-button is used to create a new unconnected ad-hoc delivery
			newDeliveryDefaults={{
				siteId: defaultSiteId,
				recipientDescription: "",
			}}
		/>
	);
};

function getFieldFromConnectedCustomerOrders(
	row: DeliveriesDataGridApi_DeliveryDto,
	getter: (row: DeliveriesDataGridApi_DeliveryDto_CustomerOrderDto) => string,
): string {
	return row.connectedCustomerOrders.map(getter).join(" | ");
}
